import { render } from "./ShortCutModal.vue?vue&type=template&id=2f89a023"
import script from "./ShortCutModal.vue?vue&type=script&lang=js"
export * from "./ShortCutModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__